import styled from 'styled-components';
import { Box } from '../../../../CommonComponents/OPL/Box/Box';
import { BREAKPOINTS } from '../../../BeFi20.meta';

export const StickyWrapper = styled(Box)(({ theme }) => ({
  position: 'sticky',
  top: 0,
  width: '100%',
  marginBottom: 24,
  background: theme.colors.bg,
  boxShadow: `inset 0 -1px 0 ${theme.colors.neutral['200']}`,
  zIndex: 1,

  [`@media (min-width: ${BREAKPOINTS.sm})`]: {
    marginBottom: 40,
  },
}));

export const Wrapper = styled(Box)({
  width: '100%',
  padding: 6,
  display: 'grid',
  gridTemplateColumns: '1fr auto 1fr',
  justifyItems: 'start',
  alignItems: 'center',

  [`@media (min-width: ${BREAKPOINTS.sm})`]: {
    padding: 14,
  },
});
